import { HttpClient } from "@/App/services/HttpClient";
import config from "@/App/config";
import { handleHttpRequest } from "@/Case/services/handleHttpRequest";

export default {
  subscribe(registrationToken: string, topic: string): Promise<any> {
    return handleHttpRequest(
      HttpClient.post(config.FIREBASE_SUBSCRIBE, {
        registrationToken,
        topic,
      }),
    );
  },
  unsubscribe(registrationToken: string, topic: string): Promise<any> {
    return handleHttpRequest(
      HttpClient.post(config.FIREBASE_UNSUBSCRIBE, {
        registrationToken,
        topic,
      }),
    );
  },
};
